import React, { useRef } from 'react';
import { useWindowScroll } from 'react-use';
import { Button } from 'ui';
import FilterModalBottomButton from '~/components/Search/FilterModal/FilterModalBottomButton';
import FilterModalTitle from '~/components/Search/FilterModal/FilterModalTitle';
import UniqueFilteringModal from '~/components/Search/FilterModal/UniqueFilteringModal';
import FilteringList, {
  FilteringListProps,
} from '~/components/Search/FilteringList/FilteringList';
import HiddenFilteringList from '~/components/Search/FilteringList/HiddenFilteringList';
import BottomSlideAndFade from '~/components/Transitions/BottomSlideAndFade';
import useFacetFiltering from '~/contexts/facetFiltering/useFacetFiltering';
import FilterIcon from '~/public/static/svg/FilterIcon';
import { useAppDispatch, useAppSelector } from '~/store/store';
import { isFilterModalOpen, setFilterModalOpen } from '~/store/ui/uiSlice';

interface Props extends FilteringListProps {}

const FloatingFilterButton: React.FC<Props> = props => {
  const facetProps = useFacetFiltering();
  const filterButtonRef = useRef<HTMLButtonElement | null>(null);
  const { y: scroll } = useWindowScroll();
  const open = useAppSelector(isFilterModalOpen);
  const dispatch = useAppDispatch();

  const openModal = () => dispatch(setFilterModalOpen({ open: true }));
  const onRequestClose = () => dispatch(setFilterModalOpen({ open: false }));

  const showFloating =
    !open &&
    scroll &&
    filterButtonRef.current &&
    scroll >
      filterButtonRef.current.offsetTop + filterButtonRef.current.offsetHeight;

  const buttonContent = (
    <>
      <FilterIcon fill="currentColor" className="mr-2" />
      Filter{facetProps.filterCount > 0 && ` (${facetProps.filterCount})`}
    </>
  );

  return (
    <>
      <Button
        color="grey"
        variant="outlined"
        size="small"
        ref={filterButtonRef}
        className="flex items-center whitespace-nowrap"
        onClick={openModal}
      >
        {buttonContent}
      </Button>

      <BottomSlideAndFade
        show={!!showFloating}
        className="fixed bottom-12 left-0 z-20 flex w-full justify-center"
      >
        <Button className="flex items-center" size="small" onClick={openModal}>
          {buttonContent}
        </Button>
      </BottomSlideAndFade>

      <HiddenFilteringList />

      <UniqueFilteringModal onRequestClose={onRequestClose} open={open}>
        <FilterModalTitle onClickApply={onRequestClose} />
        <div className="flex-1 px-4 py-3">
          {/* Forcibly show categories on lockers */}
          <FilteringList
            {...props}
            showCategoryFilters={
              facetProps.type === 'locker' || facetProps.type === 'search'
            }
            showSort
          />
        </div>
        <FilterModalBottomButton onClick={onRequestClose} />
      </UniqueFilteringModal>
    </>
  );
};

export default FloatingFilterButton;
